import * as React from 'react';

const UndoCircularChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="undo-circular-chunky_svg__eds-icon--refresh-chunky_svg"
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="undo-circular-chunky_svg__eds-icon--refresh-chunky_base"
            d="M10 8v2H4V4h2v2.7C7.5 5.1 9.6 4 12 4c4.4 0 8 3.6 8 8s-3.6 8-8 8c-1.8 0-3.5-.6-4.8-1.6l1.2-1.6c1 .7 2.3 1.2 3.6 1.2 3.3 0 6-2.7 6-6s-2.7-6-6-6c-1.8 0-3.4.8-4.5 2H10z"
        />
    </svg>
);

UndoCircularChunkySvg.displayName = 'UndoCircularChunkySvg';
export default UndoCircularChunkySvg;
